import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SharedModule } from '../../shared/shared.module';
import { SkeletonTableRowsComponent } from './components/skeleton-table-rows/skeleton-table-rows.component';
import { TableComponent } from './components/table/table.component';

const declarations = [SkeletonTableRowsComponent, TableComponent];

/** @deprecated Use `@suvo/frontend-framework/standalone/table/*`. */
@NgModule({
  imports: [CommonModule, SharedModule, NgxSkeletonLoaderModule],
  declarations,
  exports: declarations,
})
export class TablesModule {}
